import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
export default {
  $on: function $on(keys, cb) {
    typeof keys === 'string' && (keys = [keys]);
    if (keys instanceof Array) keys = keys.reduce(function (obj, key) {
      return obj[key] = cb, obj;
    }, {});
    Object.assign(this.$$arr, keys); // this.$$arr[key] = cb
  },
  $emit: function $emit(key, argv) {
    var listener = this.$$arr[key];
    listener && typeof listener === 'function' && listener(argv);
  },
  $$arr: {}
};